module.exports = __webpack_public_path__ + "static/media/nirmala.68371968.ttf";